import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateSupplierActions } from "store/ducks/settings/suppliers";

export function* createSupplierRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/supplier`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateSupplierActions.success(data));
    notify("success", "Fornecedor cadastrado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateSupplierActions.failure(errorMessage));
  }
}
